export const adminRouter = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '数据总览',
    },
    component: () => import('../views/admin/page/index'),
  },
  {
    path: 'account',
    meta: {
      title: '帐号管理',
    },
    component: () => import('../views/admin/page/account'),
  },
  {
    path: 'role',
    meta: {
      title: '角色管理',
    },
    component: () => import('../views/admin/page/role'),
  },
  {
    path: 'menus',
    meta: {
      title: '菜单管理',
    },
    component: () => import('../views/admin/page/menus'),
  },
  {
    path: 'project',
    meta: {
      title: '项目列表',
    },
    component: () => import('../views/admin/page/project'),
  },
  {
    path: 'userInfo',
    meta: {
      title: '个人中心',
    },
    component: () => import('../views/projectOffice/page/userInfo'),
  }
]